<template lang="pug">
.pa-3
  editar-datos-usuario(:username="usuario", :validar="true")
</template>
<script>
  import usuarioEditar from '@/components/c_usuario_form_editar_datos'
  export default {
    components : {
      'editar-datos-usuario': usuarioEditar
    },
    data () {
      return {
        usuario: localStorage.getItem('username')
      }
    },
    created () {
    },
    methods : {
    }
  }
</script>



// WEBPACK FOOTER //
// View_user_profile.vue?0921da2e